// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__krhB6","page":"Pagination_page__f0YM8","active":"Pagination_active__bgadc"};